import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { formatApiError } from "@/lib/api";
import { Brand } from "@/components/Brand";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(email.trim().replace(/^mailto:/i, ""), password);
      toast.success(`Selamat datang, ${user.name}!`);
      navigate("/app/dashboard");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-[#0A0D14] text-slate-100">
      <div className="w-full max-w-md">
        <Link to="/" className="flex justify-center mb-8" data-testid="login-logo">
          <Brand className="h-40 sm:h-44" />
        </Link>
        <div className="rounded-2xl border border-white/10 bg-[#141C2E] p-8">
          <h1 className="text-2xl font-bold">Masuk ke akun Anda</h1>
          <p className="text-sm text-slate-400 mt-1">Lanjutkan workflow listing & lead Anda.</p>
          <form onSubmit={onSubmit} className="mt-6 space-y-4">
            <div>
              <Label className="text-slate-300" htmlFor="email">Email atau No. HP</Label>
              <Input
                id="email" name="email" type="text" value={email} required
                inputMode="email" autoComplete="email"
                autoCapitalize="none" autoCorrect="off" spellCheck={false}
                data-testid="login-email-input"
                onChange={(e) => setEmail(e.target.value.replace(/^mailto:/i, ""))}
                className="mt-1 bg-[#0D1322] border-white/10 focus:border-orange-500"
                placeholder="agent@contoh.com atau 0812xxxxxxx"
              />
            </div>
            <div>
              <Label className="text-slate-300" htmlFor="password">Password</Label>
              <Input
                id="password" type="password" value={password} required
                data-testid="login-password-input"
                onChange={(e) => setPassword(e.target.value)}
                className="mt-1 bg-[#0D1322] border-white/10 focus:border-orange-500"
                placeholder="••••••••"
              />
            </div>
            <Button
              type="submit"
              disabled={loading}
              data-testid="login-submit-btn"
              className="w-full bg-gradient-to-r from-[#FF5722] to-[#F97316] hover:from-[#F97316] hover:to-[#EA580C] font-semibold py-6"
            >
              {loading ? "Memproses…" : "Masuk"}
            </Button>
          </form>
          <div className="mt-6 text-sm text-slate-400 text-center">
            Belum punya akun?{" "}
            <Link to="/register" className="text-orange-400 hover:text-orange-300 font-medium" data-testid="login-to-register">
              Daftar sekarang
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
